module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg1_mid.1e2c5b51.jpg";